import { useRef, useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import space from '../assets/banner.png';
import '../css/home.css';
import '../css/event.css';
import Initiatives from "../components/Initiatives";
import Footer from "../components/Footer";
import ContactForm from "../components/ContactForm";
import Landing from "../components/Landing";
import Funds from "../components/Funds";
import BackToTop from "../components/BackToTop";
import SliderComp from '../components/SliderComp';
import { useNavigate, useLocation } from "react-router-dom";


import banner1 from '../assets/banner.JPG';
import banner2 from '../assets/carousel-1.jpg';
import banner3 from '../assets/carousel-2.jpeg';
import banner4 from '../assets/carousel-3.jpg';
import banner5 from '../assets/carousel-4.jpg';
import cert1 from "../assets/certifications/cert1.jpg";
import cert2 from "../assets/certifications/cert2.jpg";
import { motion } from "framer-motion";
export default function Home() {


  const navigate = useNavigate();

  const images = [banner1, banner2, banner3, banner4, banner5];  // Add more images as needed
  const [currentIndex, setCurrentIndex] = useState(0);
  const location = useLocation();
  const fundsRef = useRef(null);
const [previewImg, setPreviewImg] = useState(null);


  // Automatically change background every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);


  useEffect(() => {
    if (location.hash === "#partners" && fundsRef.current) {
      fundsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);


const certificates = [
  require("../assets/certifications/cert1.jpg"),
  require("../assets/certifications/cert2.jpg"),
  require("../assets/certifications/cert3.jpg"),
  require("../assets/certifications/cert4.jpg"),
  require("../assets/certifications/cert5.jpg"),
  require("../assets/certifications/cert6.jpg"),
  require("../assets/certifications/cert7.jpg"),
  require("../assets/certifications/cert8.jpg"),
];

const openPreview = (imgSrc) => setPreviewImg(imgSrc);
const closePreview = () => setPreviewImg(null);


  return (
    <>
      <Navbar />
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1 }}
      >
        <div className="video-container">
          <img src={images[currentIndex]} alt="Background" className="slider-image" />
          <div className="overlay"></div>
          <div className="typewriter">
            <h2>NATIONAL HUMAN RIGHTS FEDERATION...</h2>
          </div>
        </div>
      </motion.div>


      <motion.div
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1 }}
      >
        <Landing />
      </motion.div>

      {/* <Initiatives /> */}

      <SliderComp />
      <div ref={fundsRef}>
        <Funds />
      </div>

      <div className="event">
        <div className="container">
          <div className="section-header">
            <h3>Our Events</h3>
          </div>

          <div className="eventwriter">
            <h2>Stay Updated with Our Latest Events...</h2>
          </div>

          <div className="event-btn-container">
            <button
              onClick={() => navigate("/event")}
              className="event-btn"
            >
              View Events
            </button>
          </div>
        </div>
      </div>

{/* ---------- CERTIFICATION SECTION ---------- */}
    <div className="certification-section">
      <div className="container">
        <div className="section-header">
          <h3>Certifications & Recognitions</h3>
          <h2>Our Achievements and Global Honors</h2>
          <p className="cert-subtext">
            Each certificate represents our continuous effort, passion, and
            recognition for promoting human rights, social justice, and equality.
          </p>
        </div>

        <div className="cert-grid">
          {certificates.map((cert, index) => (
            <div key={index} className="cert-item" onClick={() => openPreview(cert)}>
              <img src={cert} alt={`Certificate ${index + 1}`} className="cert-img" />
            </div>
          ))}
        </div>
      </div>
    </div>

    {previewImg && (
      <div className="cert-preview-overlay" onClick={closePreview}>
        <img src={previewImg} alt="Full Certificate" />
      </div>
    )}




      {/* <ContactForm /> */}

      <div className="contact">
        <div className="container">
          <div className="section-header">
            <h3>Get In Touch</h3>
            <h2>Contact for any query</h2>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "40px 0",
            }}
          >
            <button
              onClick={() => navigate("/contact")}
              style={{
                backgroundColor: "#007bff",
                color: "#fff",
                border: "none",
                padding: "15px 30px",
                borderRadius: "30px",
                fontSize: "18px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.3s ease-in-out",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#0056b3";
                e.target.style.transform = "scale(1.05)";
                e.target.style.boxShadow = "0 6px 15px rgba(0, 0, 0, 0.3)";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#007bff";
                e.target.style.transform = "scale(1)";
                e.target.style.boxShadow = "0 4px 10px rgba(0, 0, 0, 0.2)";
              }}
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
      <Footer />
      <BackToTop />
    </>
  );
}